import Image from '@redbubble/design-system/src/Image';
import {
  ListContent,
  ListItem,
  ListMedia,
} from '@redbubble/design-system/src/List';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { thumbsUpIcon } from '../../../../components/TrustSignal';

export const messages = defineMessages({
  returnPolicyTitle: {
    defaultMessage: 'Super-easy returns',
  },
  returnPolicyDescription: {
    defaultMessage: 'Problem? No problem. We’ll fix it, fast.',
  },
});

interface ReturnPolicyTrustSignalProps {
  locale: string;
}

export const ReturnPolicyTrustSignal = ({
  locale,
}: ReturnPolicyTrustSignalProps) => {
  const intl = useIntl();

  return (
    <ListItem>
      <ListMedia>
        <Image alt="" src={thumbsUpIcon.src} height={28} width={28} />
      </ListMedia>
      <ListContent>
        <Text type="display5" display="block">
          {intl.formatMessage(messages.returnPolicyTitle)}
        </Text>
        <Text display="block" type="body2">
          {intl.formatMessage(messages.returnPolicyDescription)}
        </Text>
      </ListContent>
    </ListItem>
  );
};
